// extracted by mini-css-extract-plugin
export default {"modal":"UpgradeModal_modal__cm+F5","star":"UpgradeModal_star__oHsWB","listItem":"UpgradeModal_listItem__K0w2T","listWrapper":"UpgradeModal_listWrapper__5i37F"};